import { Component, OnInit,ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { MenuItems,MenuI } from 'src/app/shared/menu-items/menu-items';
import { DemoMaterialModule } from 'src/app/demo-material-module';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SidenavService } from '@services/varios/sidenav.service';
import { SideNavCls } from "@env/environment";
import { VersionModule } from 'src/app/components/version/version.module';
import { ToolsService } from '@services/varios/tools.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports:[DemoMaterialModule, NgFor, NgIf, RouterModule, CommonModule, MatIconModule, VersionModule],
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements AfterViewInit{

  public menus:MenuI[] = [];

  constructor(

    menuItems: MenuItems,
    private readonly el: ElementRef, 
    private readonly renderer: Renderer2,
    private readonly sidenavService: SidenavService,
    public readonly toolsService: ToolsService
  ) {

    this.menus = menuItems.getMenuitem();
  }

  ngAfterViewInit(): void {
    if (this.sidenavService.sidenavWidth === SideNavCls) {    
      this.sidenavService.setSidenavWidth(SideNavCls);
      const elementosHid = this.el.nativeElement.querySelectorAll('.hid');
      elementosHid.forEach((elemento : HTMLElement) => {
        this.renderer.setStyle(elemento, 'display', 'none');
      });
    } 
  }
 
  toggleExpansion(itemId?: number): void {   
    if(itemId == undefined) {        
      sessionStorage.removeItem('IDM');
    } else {
      sessionStorage.setItem('IDM', itemId.toString());
    }
  }
}
